<mat-form-field
        [ngClass]="{'outline': outlined}"
        [appearance]="asFormsControl().outline ? 'outline' : 'legacy'"
        [floatLabel]="outlined ? 'always' : !asFormsControl().floatingLabelNever ? 'auto' : 'never'"
        class="app-datepicker"
>
    <mat-label *ngIf="asFormsControl().outline && !asFormsControl().floatingLabelNever">{{ asFormsControl().placeholder }}</mat-label>

    <input
            matInput
            #datepickerInput
            readonly
            [matDatepicker]="datepicker"
            [min]="asFormsControl().minDate"
            [max]="asFormsControl().maxDate"
            [placeholder]="asFormsControl().placeholder"
            (click)="openDatepicker(datepicker)"
            (dateChange)="changeValue($event)"
            [disabled]="asFormsControl().disabled || disabled"
            [ngClass]="{'outline': outlined}"

            [(ngModel)]="asFormsControl().value"
    >
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>

    <mat-datepicker
        #datepicker
        [ngClass]="{'outline': outlined}"
        [disabled]="asFormsControl().disabled || disabled"
        [startAt]="asFormsControl().value"
        (opened)="onTouched && onTouched()"
    ></mat-datepicker>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>

